import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var EboxDetailCtrl = function (fn, er, /*caseId,*/ gestore, token, ids) {
	var caseId = sessionStorage.getItem('caseId')
	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};

	var data = {
		caseID: caseId
	};

	axios
		.post(ApiConfig.url.EBOX_DETAIL, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { EboxDetailCtrl };